module.exports = __webpack_public_path__ + "img/RECUADRO_Aprendizaje.5404cf58.png";